import React from 'react';
import { Page } from '../Page';
export function Page2() {
  return <Page pageNumber={6} variant="light" data-id="element-362">
      <div className="flex flex-col h-full" data-id="element-363">
        {/* Accent image strip */}
        <div className="h-[160px] -mx-12 -mt-10 mb-8 overflow-hidden relative" data-id="element-364">
          <img src="https://images.unsplash.com/photo-1490818387583-1baba5e638af?w=1000&q=80" alt="Healthy food spread" className="w-full h-full object-cover object-center" data-id="element-365" />
          <div className="absolute inset-0 bg-gradient-to-t from-[#F5F5F0] via-transparent to-transparent" data-id="element-366" />
        </div>

        <div className="mb-8" data-id="element-367">
          <p className="text-[10px] font-bold text-tealslate uppercase tracking-[0.2em] mb-3" data-id="element-368">
            The Fundamentals
          </p>
          <h1 className="text-5xl font-serif text-[#1F1F1F] leading-tight mb-4" data-id="element-369">
            The <span className="text-tealslate" data-id="element-370">Fundamentals</span>
          </h1>
          <div className="w-16 h-0.5 bg-tealslate" data-id="element-371" />
        </div>

        <div className="grid grid-cols-2 gap-10 mb-12" data-id="element-372">
          <div className="space-y-4" data-id="element-373">
            <p className="text-sm text-[#3B3B3B] leading-[1.8]" data-id="element-374">
              Traditional nutrition advice starts with calories. Count them, cut
              them, track them. Everything else comes second. For most people,
              that's still the playbook.
            </p>
            <p className="text-sm text-[#3B3B3B] leading-[1.8]" data-id="element-375">
              But GLP-1 medication flips the script. The medication is already
              creating your caloric deficit by reducing appetite and slowing
              digestion. So calories move to the bottom of the list.
            </p>
          </div>
          <div className="space-y-4" data-id="element-376">
            <p className="text-sm text-[#3B3B3B] leading-[1.8]" data-id="element-377">
              That changes everything. Now you build from the ground up.
              Protein, vitamins, omega-3s, fiber, and weight lifting become your
              foundation. These are the nutrients and habits that protect your
              muscle, your energy, and your health while the medication handles
              the rest.
            </p>
            <p className="text-sm text-[#3B3B3B] leading-[1.8]" data-id="element-378">
              All five are equally important. They are not ranked. They work
              together. And you can realistically start all of them today.
            </p>
          </div>
        </div>

        {/* Pyramid */}
        <div className="flex-1 flex flex-col items-center justify-center space-y-3 w-full max-w-lg mx-auto" data-id="element-379">
          <div className="w-1/3 bg-tealslate text-white py-3 text-center font-bold text-sm shadow-sm" data-id="element-380">
            Protein
          </div>
          <div className="w-1/2 bg-[#7A9BA5] text-white py-3 text-center font-bold text-sm shadow-sm" data-id="element-381">
            Vitamins & Minerals
          </div>
          <div className="w-2/3 bg-[#6B8A94] text-white py-3 text-center font-bold text-sm shadow-sm" data-id="element-382">
            Omega-3 Fatty Acids
          </div>
          <div className="w-5/6 bg-[#5C7983] text-white py-3 text-center font-bold text-sm shadow-sm" data-id="element-383">
            Fiber
          </div>
          <div className="w-full bg-[#4D6872] text-white py-3 text-center font-bold text-sm shadow-sm" data-id="element-384">
            Weight Lifting
          </div>
        </div>
      </div>
    </Page>;
}